'use client'

import type { ComponentProps } from 'react'

import NextLink from 'next/link'
import React from 'react'

/**
 * Props for the Link component
 */
export interface ZLinkProps extends ComponentProps<typeof NextLink> {}

/**
 * Link - Universal Link Component
 *
 * A wrapper around Next.js Link component.
 * This component maintains all standard Next.js Link functionality .
 *
 * @example
 * ```tsx
 * // Standard link without tracking
 * <Link href="/about">About Us</Link>
 * ```
 */
const ZLink = ({
	onClick,
	href,
	children,
	...linkProps
}: ZLinkProps) => {
	const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
		// Call original onClick handler if provided
		if (onClick) {
			onClick(event)
		}
	}

	return (
		<NextLink href={href} onClick={handleClick} {...linkProps}>
			{children}
		</NextLink>
	)
}

export default ZLink
